module.exports = __webpack_public_path__ + "img/hello.0cbbf51d.png";